// extracted by mini-css-extract-plugin
export var addressFields = "_kk-0";
export var animationContainer = "_kk-1";
export var footer = "_kk-2";
export var lineItems = "_kk-3";
export var modalContent = "_kk-4";
export var orderName = "_kk-5";
export var strong = "_kk-6";
export var warning = "_kk-7";